import React from 'react';
import { motion } from 'framer-motion';
import { FiLock, FiArrowRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const AuthLockedView = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            position: 'fixed',
            top: '64px', // Below navbar (h-16)
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px'
        }}>
            {/* Blur Backdrop */}
            <div style={{
                position: 'absolute',
                inset: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                backdropFilter: 'blur(12px)',
                zIndex: 0
            }} />

            {/* Content Card */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                style={{
                    position: 'relative',
                    zIndex: 1,
                    maxWidth: '480px',
                    width: '100%',
                    padding: '40px',
                    background: 'rgba(255, 255, 255, 0.03)',
                    backdropFilter: 'blur(20px)',
                    borderRadius: '32px',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    textAlign: 'center',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
                }}
            >
                <motion.div
                    animate={{ scale: [1, 1.1, 1] }}
                    transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                    style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '24px',
                        backgroundColor: 'rgba(34, 197, 94, 0.1)',
                        border: '1px solid rgba(34, 197, 94, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 32px',
                        color: '#22c55e',
                        fontSize: '32px'
                    }}
                >
                    <FiLock />
                </motion.div>

                <h2 style={{ fontSize: '28px', fontWeight: 800, color: '#fff', marginBottom: '12px' }}>
                    Access Restricted
                </h2>
                <p style={{ color: '#9ca3af', lineHeight: 1.6, marginBottom: '32px', fontSize: '15px' }}>
                    CodeCampus tech library and premium roadmaps are available exclusively for our community members. Join us today to unlock all resources!
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={() => navigate('/signup')}
                        style={{
                            padding: '16px',
                            borderRadius: '16px',
                            backgroundColor: '#22c55e',
                            color: '#fff',
                            fontSize: '16px',
                            fontWeight: 700,
                            border: 'none',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            boxShadow: '0 10px 15px -3px rgba(34, 197, 94, 0.3)'
                        }}
                    >
                        Create Free Account <FiArrowRight />
                    </motion.button>

                    <button
                        onClick={() => navigate('/login')}
                        style={{
                            padding: '16px',
                            color: '#9ca3af',
                            fontSize: '14px',
                            fontWeight: 600,
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        Already a member? <span style={{ color: '#22c55e' }}>Sign In</span>
                    </button>
                </div>
            </motion.div>
        </div>
    );
};

export default AuthLockedView;
